import { Box, useTheme } from "@mui/material"

export const FullHeightLayout = ({ children }) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`AppFullHeightLayout`]?.styleOverrides || {}
  const { root } = styleOverrides
  return <Box sx={root}>{children}</Box>
}
